export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=65a22ed8"


//////////////////
// WEBPACK FOOTER
// ./src/components/content/links/list.vue?vue&type=template&id=65a22ed8
// module id = 0Xo7
// module chunks = 0